import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './themes/theme';
// import './debug-borders.css'; // 🔍 DEBUG TEMPORÁRIO - REMOVIDO

// 🚨 Fallback automático para ChunkLoadError
window.addEventListener('error', (event) => {
  if (event.message.includes('Loading chunk') || event.message.includes('ChunkLoadError')) {
    console.warn('[ChunkLoadError] Detectado - Recarregando aplicação...');
    window.location.reload();
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
